import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { GraduationCap } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { useTrainerBatches } from '@/lib/hooks/useTrainer';

export const Route = createFileRoute('/trainer/batches/')({
  beforeLoad: () => {
    const { isAuthenticated, hasRole } = useAuthStore.getState();
    if (!isAuthenticated) throw redirect({ to: '/login' });
    if (!hasRole('trainer', 'super_admin')) throw redirect({ to: '/dashboard' });
  },
  component: BatchesIndex,
});

export function BatchesIndex() {
  const { data: batches, isLoading } = useTrainerBatches();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && batches && batches.length > 0) {
      navigate({ to: '/trainer/batches/$batchId/overview', params: { batchId: batches[0].id }, replace: true });
    }
  }, [batches, isLoading, navigate]);

  if (isLoading || (batches && batches.length > 0)) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#ff5a1f] border-t-transparent" />
      </div>
    );
  }

  if (!batches || batches.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center text-[#6b7280]">
        <div className="text-center">
          <GraduationCap className="mx-auto mb-3 h-10 w-10 opacity-40" />
          <p className="text-sm">No batches assigned to you yet.</p>
        </div>
      </div>
    );
  }

  return null;
}
